/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Route_Error_TitleInputs */

const en_route_error_title = /** @type {(inputs: Route_Error_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error loading this page`)
};

const es_route_error_title = /** @type {(inputs: Route_Error_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al cargar esta pagina`)
};

/**
* | output |
* | --- |
* | "Error loading this page" |
*
* @param {Route_Error_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const route_error_title = /** @type {((inputs?: Route_Error_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Route_Error_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_route_error_title(inputs)
	return es_route_error_title(inputs)
});